//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"GetModelPlantRoot",{R_:{modelPlantRoot:"LineDesigner.ModelPlantRoot"}},0,0],[["modelPlantRoot"],"ReadPlantModel",{R_:{plantRoot:"NXObject"}},1,0],[["modelPlantRoot"],"CleanPlantModel",{},1,0],[["modelPlantRoot","activate"],"ActivatePlantModel",{},2,0],[["modelPlantRoot","productionUnit","keep"],"SetTargetProductionUnit",{},3,0],[["modelPlantRoot"],"RestoreTargetProductionUnit",{},1,0],[["modelPlantRoot","resourceInstances","newParent"],"MoveResourceInstances",{},3,0],[["modelPlantRoot","productionUnitToObsolete"],"ObsoleteProductionUnit",{},2,0]],[]];
SPLM.LineDesigner.ModelPlantManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.ModelPlantManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;